/**
 * Dane porównawcze platform — używane na stronach /porownanie/...
 */

export interface ComparisonRow {
  feature: string;
  a: string | { value: string; highlight?: boolean };
  b: string | { value: string; highlight?: boolean };
  category?: string;
}

export interface ComparisonData {
  slug: string;
  title: string; // pełen H1 + meta title
  metaDescription: string;
  excerpt: string;
  platformA: { name: string; tagline: string; bestFor: string };
  platformB: { name: string; tagline: string; bestFor: string };
  intro: string;
  rows: ComparisonRow[];
  verdict: { headline: string; whenA: string[]; whenB: string[]; whenBoth?: string[] };
  faq: { q: string; a: string }[];
  keywords: string[];
}

export const COMPARISONS: ComparisonData[] = [
  // ===========================================
  // BaseLinker vs SellAsist
  // ===========================================
  {
    slug: "baselinker-vs-sellasist",
    title: "Baselinker vs SellAsist 2026 — który system wybrać do sprzedaży wielokanałowej?",
    metaDescription:
      "Baselinker vs SellAsist — szczegółowe porównanie 2026: funkcje, ceny, integracje, automatyzacje. Konkretna rekomendacja dla różnych typów sklepów.",
    excerpt:
      "Najczęstsze pytanie polskich e-commerce'ów: BaseLinker czy SellAsist? Porównuję oba systemy w 30 punktach i mówię, kiedy wybrać który.",
    keywords: ["baselinker vs sellasist", "porównanie baselinker sellasist", "sellasist czy baselinker"],
    platformA: {
      name: "Baselinker",
      tagline: "centrum operacyjne e-commerce",
      bestFor: "Sprzedaż wielokanałowa, międzynarodowa, integracja ERP",
    },
    platformB: {
      name: "SellAsist",
      tagline: "polski specjalista od marketplace'ów",
      bestFor: "Dominacja sprzedaży na Allegro, polski rynek",
    },
    intro:
      'Baselinker i SellAsist to dwa największe polskie systemy do zarządzania sprzedażą wielokanałową. Często widzę firmy, które wybierają jeden z nich na ślepo, bo „ktoś polecił". A różnice są realne i mają wpływ na efektywność operacyjną. Porównuję je w 30 punktach po latach wdrażania obu platform.',
    rows: [
      { category: "Cennik", feature: "Plan startowy (PLN/mies.)", a: "39 zł (BASIC, 100 zam.)", b: "199 zł (Standard)" },
      { category: "Cennik", feature: "Plan średni (1000-3000 zam.)", a: "199 zł (START)", b: "399-599 zł" },
      { category: "Cennik", feature: "Model rozliczeń", a: "Zamówienia/mies.", b: "Liczba ofert + funkcje" },
      { category: "Allegro", feature: "Bezpośrednia integracja Allegro", a: "Tak", b: { value: "Tak (lepiej rozbudowana)", highlight: true } },
      { category: "Allegro", feature: "Repricer Allegro", a: "Podstawowy", b: { value: "Zaawansowany (najlepszy w PL)", highlight: true } },
      { category: "Allegro", feature: "Masowe wystawianie ofert", a: "Tak", b: { value: "Tak (szablony zaawansowane)", highlight: true } },
      { category: "Allegro", feature: "Wsparcie SMART! i opcji Allegro", a: "Tak", b: { value: "Tak (natywne)", highlight: true } },
      { category: "Marketplace", feature: "Amazon", a: { value: "Tak (kilkanaście rynków)", highlight: true }, b: "Tak (ograniczone)" },
      { category: "Marketplace", feature: "eBay", a: { value: "Tak (globalnie)", highlight: true }, b: "Tak (głównie .de, .pl)" },
      { category: "Marketplace", feature: "Empik, Kaufland, Erli", a: "Tak", b: "Tak" },
      { category: "Marketplace", feature: "Etsy, Shopee", a: { value: "Tak", highlight: true }, b: "Nie" },
      { category: "Sklepy", feature: "Liczba integracji sklepów", a: { value: "20+", highlight: true }, b: "10+" },
      { category: "Sklepy", feature: "Shopify", a: { value: "Tak (native)", highlight: true }, b: "Tak (przez API)" },
      { category: "Sklepy", feature: "Shoper, ShopGold, PrestaShop", a: "Tak", b: "Tak" },
      { category: "Kurierzy", feature: "InPost, DPD, DHL, GLS, Pocztex", a: "Tak", b: "Tak" },
      { category: "Kurierzy", feature: "Międzynarodowi (UPS, FedEx)", a: { value: "Tak", highlight: true }, b: "Częściowo" },
      { category: "ERP", feature: "Comarch ERP (Optima, XL)", a: { value: "Tak (głęboka)", highlight: true }, b: "Tak (podstawowa)" },
      { category: "ERP", feature: "Subiekt GT/nexo", a: { value: "Tak", highlight: true }, b: "Tak" },
      { category: "ERP", feature: "Enova365, WAPRO", a: "Tak", b: "Częściowo" },
      { category: "Automatyzacje", feature: "Scenariusze automatyczne", a: { value: "Tak (potężne)", highlight: true }, b: "Tak (podstawowe)" },
      { category: "Automatyzacje", feature: "Akcje warunkowe", a: { value: "Tak", highlight: true }, b: "Ograniczone" },
      { category: "Automatyzacje", feature: "Webhooki i API", a: { value: "Tak (rozbudowane)", highlight: true }, b: "Tak (podstawowe)" },
      { category: "Wydajność", feature: "Limity API", a: "Wysokie", b: "Średnie" },
      { category: "Wydajność", feature: "Skalowalność (10k+ zam./mies.)", a: { value: "Tak", highlight: true }, b: "Z limitami" },
      { category: "Support", feature: "Polski support", a: "Tak", b: { value: "Tak (lepszy)", highlight: true } },
      { category: "Support", feature: "Baza wiedzy / dokumentacja", a: { value: "Bardzo dobra", highlight: true }, b: "Dobra" },
      { category: "Support", feature: "Społeczność (FB groups)", a: { value: "Bardzo aktywna", highlight: true }, b: "Aktywna" },
      { category: "Wdrożenie", feature: "Czas standardowego wdrożenia", a: "2-3 tygodnie", b: "2-4 tygodnie" },
      { category: "Wdrożenie", feature: "Koszt standardowego wdrożenia", a: "4-12 tys. zł", b: "4-10 tys. zł" },
      { category: "Wdrożenie", feature: "Krzywa nauki dla zespołu", a: "Średnia (rozbudowane)", b: { value: "Niska (intuicyjny)", highlight: true } },
    ],
    verdict: {
      headline: "Wybierz Baselinker dla skalowalności, SellAsist dla dominacji na Allegro",
      whenA: [
        "Twój sklep ma 3+ kanały sprzedaży (sklep + 2+ marketplace'y)",
        "Sprzedajesz globalnie (Amazon DE/UK/US, eBay, Etsy)",
        "Potrzebujesz głębokiej integracji z ERP (Comarch, Subiekt)",
        "Planujesz przekroczyć 5000 zamówień miesięcznie",
        "Chcesz zaawansowanych automatyzacji warunkowych",
      ],
      whenB: [
        "80%+ Twojej sprzedaży idzie przez Allegro",
        "Repricer i strategia cenowa Allegro to dla Ciebie kluczowe narzędzia",
        "Cenisz prostotę obsługi i intuicyjny interfejs",
        "Twój zespół jest mniejszy (1-3 osoby) i nie chce uczyć się rozbudowanego systemu",
        "Sprzedajesz głównie w Polsce, mało lub wcale za granicą",
      ],
      whenBoth: [
        "W większych firmach (5+ osób, multi-warehouse, multi-brand) często wdrażam OBA systemy równolegle: SellAsist do zarządzania ofertami i magazynem na Allegro, Baselinker do orkiestracji zamówień, kurierów i integracji ERP/marketing.",
      ],
    },
    faq: [
      {
        q: "Czy mogę przejść z SellAsista na Baselinker później?",
        a: "Tak. Migracja jest możliwa, ale czasochłonna (3-6 tygodni). Lepiej dobrze wybrać na start. Zwykle pomagam w takich migracjach.",
      },
      {
        q: "Który system jest tańszy w dłuższej perspektywie?",
        a: "Dla małych sklepów (do 1000 zam./mies.) — Baselinker. Dla większych z dużą sprzedażą Allegro — SellAsist (mniej manualnej pracy = niższe koszty operacyjne).",
      },
      {
        q: "Czy oba systemy mają taką samą jakość integracji z Allegro?",
        a: "SellAsist ma głębszą i bardziej dopracowaną integrację z Allegro (lepszy repricer, lepsze wsparcie SMART!). Baselinker pokrywa wszystkie podstawowe funkcje, ale w niektórych zaawansowanych scenariuszach SellAsist wygrywa.",
      },
    ],
  },

  // ===========================================
  // ShopGold vs Shoper
  // ===========================================
  {
    slug: "shopgold-vs-shoper",
    title: "ShopGold vs Shoper 2026 — która polska platforma e-commerce jest lepsza?",
    metaDescription:
      "ShopGold vs Shoper — porównanie 2026: cena, funkcje, SEO, skalowalność, integracje. Konkretna rekomendacja dla różnych profili sklepów online.",
    excerpt:
      "Wybierasz między ShopGoldem a Shoperem? Porównuję obie polskie platformy w 25 punktach z perspektywy tego, co realnie wpływa na sprzedaż.",
    keywords: ["shopgold vs shoper", "shoper czy shopgold", "porównanie shopgold shoper"],
    platformA: {
      name: "ShopGold",
      tagline: "rozbudowany silnik dla większej skali",
      bestFor: "Sklepy z 5000+ produktów, dropshipping, B2B",
    },
    platformB: {
      name: "Shoper",
      tagline: "elastyczna platforma dla rosnących sklepów",
      bestFor: "Średnie sklepy B2C z budżetem na rozwój",
    },
    intro:
      'ShopGold i Shoper to dwie najpopularniejsze polskie platformy e-commerce. Pytanie „który wybrać?" pada u mnie w mailach co tydzień. Odpowiedź zawsze zależy od profilu biznesu — pokazuję 25 konkretnych różnic i mówię, kiedy wybrać który.',
    rows: [
      { category: "Cennik", feature: "Plan startowy (PLN/mies.)", a: "75 zł", b: "139 zł" },
      { category: "Cennik", feature: "Plan średni (z najpopularniejszymi funkcjami)", a: "150-300 zł", b: "300-600 zł" },
      { category: "Cennik", feature: "Plan Enterprise", a: "indywidualnie", b: "indywidualnie" },
      { category: "Cennik", feature: "Prowizja od sprzedaży", a: { value: "Brak", highlight: true }, b: { value: "Brak (poza Premium)", highlight: false } },
      { category: "Funkcje", feature: "Liczba produktów (bez limitów)", a: { value: "Tak (świetnie radzi sobie z 50k+)", highlight: true }, b: "Tak (w zależności od planu)" },
      { category: "Funkcje", feature: "Warianty produktów", a: "Tak (rozbudowane)", b: "Tak" },
      { category: "Funkcje", feature: "B2B (cenniki indywidualne)", a: { value: "Tak (mocne)", highlight: true }, b: "Tak (dodatek)" },
      { category: "Funkcje", feature: "Dropshipping z hurtowni", a: { value: "Tak (najlepsze w PL)", highlight: true }, b: "Częściowo" },
      { category: "Funkcje", feature: "Multi-warehouse", a: "Tak", b: "Tak" },
      { category: "Funkcje", feature: "System promocji i kuponów", a: { value: "Bardzo rozbudowany", highlight: true }, b: "Rozbudowany" },
      { category: "Design", feature: "Liczba szablonów", a: "Średnio", b: { value: "Bardzo dużo (i nowoczesne)", highlight: true } },
      { category: "Design", feature: "Customizacja wizualna", a: "Średnia", b: { value: "Wysoka", highlight: true } },
      { category: "Design", feature: "Mobile-first templates", a: "Tak", b: { value: "Tak (lepsze)", highlight: true } },
      { category: "SEO", feature: "Edycja meta i URL", a: "Tak", b: "Tak" },
      { category: "SEO", feature: "Schema.org Product", a: "Tak", b: "Tak" },
      { category: "SEO", feature: "Core Web Vitals (out-of-the-box)", a: "Średnie", b: { value: "Lepsze", highlight: true } },
      { category: "SEO", feature: "Blog wbudowany", a: "Tak", b: { value: "Tak (bardziej rozbudowany)", highlight: true } },
      { category: "Integracje", feature: "Baselinker", a: "Tak (natywna)", b: "Tak (natywna)" },
      { category: "Integracje", feature: "Allegro / marketplace'y", a: "Tak (przez Baselinker)", b: "Tak (przez Baselinker)" },
      { category: "Integracje", feature: "Płatności (PayU, Przelewy24, Tpay, BLIK)", a: "Tak", b: "Tak" },
      { category: "Integracje", feature: "Marketing (GA4, Pixel, Klaviyo)", a: "Tak", b: { value: "Tak (lepsze moduły)", highlight: true } },
      { category: "Customizacja", feature: "Dostęp do kodu szablonu", a: { value: "Pełen", highlight: true }, b: "Pełen" },
      { category: "Customizacja", feature: "Aplikacje/dodatki w marketplace", a: "Średnio", b: { value: "Bardzo dużo", highlight: true } },
      { category: "Wsparcie", feature: "Polski support", a: "Tak", b: "Tak" },
      { category: "Wsparcie", feature: "Społeczność i baza wiedzy", a: "Średnia", b: { value: "Bardzo dobra", highlight: true } },
    ],
    verdict: {
      headline: "ShopGold dla skali i specyficznych potrzeb, Shoper dla jakości i ekosystemu",
      whenA: [
        "Masz 5000+ produktów (zwłaszcza z hurtowni)",
        "Prowadzisz dropshipping z wielu źródeł",
        "Twój sklep ma silne wymagania B2B (kredyt kupiecki, cenniki indywidualne)",
        "Cenisz niższą cenę startową",
        "Masz programistę do customowych modyfikacji",
      ],
      whenB: [
        "Twój sklep ma do 5000 produktów",
        "Zależy Ci na nowoczesnym wyglądzie i UX out-of-the-box",
        "Potrzebujesz dużego ekosystemu aplikacji i integracji",
        "Stawiasz na content marketing (blog, SEO)",
        "Wolisz lepsze wsparcie i większą społeczność",
      ],
    },
    faq: [
      {
        q: "Czy mogę przejść z ShopGolda na Shopera (lub odwrotnie)?",
        a: "Tak, ale to migracja — 3-6 tygodni dla średniego sklepu. Wymaga przeniesienia produktów, klientów, zamówień, mapowania URL-i pod SEO.",
      },
      {
        q: "Która platforma jest lepsza pod SEO?",
        a: "Obie pozwalają na dobre SEO, ale Shoper out-of-the-box ma lepsze Core Web Vitals i bardziej rozbudowany blog. ShopGold wymaga więcej pracy optymalizacyjnej.",
      },
      {
        q: "Która platforma lepiej współpracuje z Baselinkerem?",
        a: "Obie mają natywną, stabilną integrację. Z mojego doświadczenia oba systemy działają równie dobrze z BL.",
      },
    ],
  },

  // ===========================================
  // Shopify vs PrestaShop
  // ===========================================
  {
    slug: "shopify-vs-prestashop",
    title: "Shopify vs PrestaShop 2026 — SaaS czy open-source dla Twojego sklepu?",
    metaDescription:
      "Shopify vs PrestaShop — porównanie 2026: koszty, funkcje, customizacja, SEO, skalowalność. Konkretna rekomendacja dla polskich sklepów e-commerce.",
    excerpt:
      "Klasyczny dylemat: Shopify (SaaS) czy PrestaShop (open-source)? Porównuję oba podejścia w 25 punktach — z perspektywy realnych kosztów i potrzeb.",
    keywords: ["shopify vs prestashop", "prestashop czy shopify", "porównanie shopify prestashop"],
    platformA: {
      name: "Shopify",
      tagline: "globalny lider SaaS",
      bestFor: "Szybki start, skalowalność, międzynarodowa sprzedaż",
    },
    platformB: {
      name: "PrestaShop",
      tagline: "elastyczny open-source",
      bestFor: "Pełna kontrola, custom funkcjonalności, większy budżet techniczny",
    },
    intro:
      "Shopify vs PrestaShop to fundamentalny wybór: wynajem (SaaS) vs własność (open-source). Nie ma jednej dobrej odpowiedzi — wszystko zależy od profilu biznesu, budżetu technicznego i planów rozwoju. Pokazuję 25 konkretnych różnic.",
    rows: [
      { category: "Model", feature: "Hosting", a: "W cenie (Shopify managed)", b: "Własny (10-200 zł/mies.)" },
      { category: "Model", feature: "Aktualizacje i bezpieczeństwo", a: { value: "Automatyczne", highlight: true }, b: "Twoja odpowiedzialność" },
      { category: "Model", feature: "Dostęp do kodu źródłowego", a: "Ograniczony", b: { value: "Pełen", highlight: true } },
      { category: "Cennik", feature: "Plan startowy (USD/mies.)", a: "$29 (Basic)", b: { value: "$0 (open-source)", highlight: true } },
      { category: "Cennik", feature: "Plan Pro/Plus", a: "$79 / $2000+", b: "Hosting + developer" },
      { category: "Cennik", feature: "Prowizja Shopify Payments / kart", a: "1.6% + 0.20 zł", b: { value: "Brak", highlight: true } },
      { category: "Cennik", feature: "Prowizje od bramek zewnętrznych", a: "1-2% (poza Shopify Payments)", b: { value: "Brak", highlight: true } },
      { category: "Cennik", feature: "Realny koszt 12 mies. (mały sklep)", a: "$348 + payments", b: "0-2400 zł (hosting + developer)" },
      { category: "Cennik", feature: "Realny koszt 12 mies. (średni sklep)", a: "$948 + apps + payments", b: "5-25 tys. zł (rozwój + utrzymanie)" },
      { category: "Funkcje", feature: "App store / moduły", a: { value: "8000+ aplikacji (płatne)", highlight: true }, b: "5000+ modułów (płatne i darmowe)" },
      { category: "Funkcje", feature: "Multi-store", a: "Tak (Plus)", b: { value: "Tak (natywnie)", highlight: true } },
      { category: "Funkcje", feature: "Multi-currency", a: { value: "Tak (świetne)", highlight: true }, b: "Tak (mniej dopracowane)" },
      { category: "Funkcje", feature: "B2B", a: "Tak (Plus)", b: { value: "Tak (natywnie)", highlight: true } },
      { category: "Customizacja", feature: "Edycja szablonów (Liquid / Smarty)", a: "Tak (Liquid)", b: "Tak (Smarty)" },
      { category: "Customizacja", feature: "Custom moduły bez ograniczeń", a: "Ograniczone API", b: { value: "Pełna", highlight: true } },
      { category: "Customizacja", feature: "Headless commerce (storefront API)", a: { value: "Tak (Hydrogen)", highlight: true }, b: "Tak (przez API)" },
      { category: "SEO", feature: "Edycja meta, schema, URL", a: "Tak", b: "Tak" },
      { category: "SEO", feature: "Core Web Vitals out-of-the-box", a: { value: "Bardzo dobre", highlight: true }, b: "Średnie (zależy od konfiguracji)" },
      { category: "SEO", feature: "Blog wbudowany", a: "Tak", b: "Tak" },
      { category: "Integracje PL", feature: "Baselinker", a: "Tak (natywna)", b: "Tak (natywna)" },
      { category: "Integracje PL", feature: "Płatności PL (PayU, Przelewy24, BLIK)", a: "Tak (przez moduły)", b: "Tak (natywne moduły)" },
      { category: "Integracje PL", feature: "InPost, DPD, DHL, GLS", a: "Tak (przez moduły)", b: "Tak" },
      { category: "Wsparcie", feature: "Oficjalny support", a: { value: "24/7 chat (po angielsku)", highlight: true }, b: "Społeczność + agencje" },
      { category: "Wsparcie", feature: "Polskie agencje / specjaliści", a: "Coraz więcej", b: { value: "Bardzo dużo", highlight: true } },
      { category: "Skalowalność", feature: "Obsługa peaków sprzedażowych", a: { value: "Bez problemów (managed)", highlight: true }, b: "Zależy od hostingu" },
    ],
    verdict: {
      headline: "Shopify dla szybkości, PrestaShop dla wolności",
      whenA: [
        "Chcesz uruchomić sklep szybko (kilka dni vs kilka tygodni)",
        "Nie masz dewelopera w zespole",
        "Cenisz brak troski o hosting, aktualizacje, bezpieczeństwo",
        "Sprzedajesz międzynarodowo (multi-currency, multi-language)",
        "Chcesz dostępu do największego App Store w e-commerce",
      ],
      whenB: [
        "Potrzebujesz custom funkcjonalności, których SaaS nie pozwala",
        "Masz dewelopera lub stałą agencję techniczną",
        "Cenisz niezależność od jednego dostawcy",
        "Twój sklep ma rozbudowany B2B z nietypowymi procesami",
        "Chcesz uniknąć prowizji Shopify Payments przy dużym obrocie",
      ],
    },
    faq: [
      {
        q: "Który system jest tańszy w długim okresie?",
        a: "Dla małego/średniego sklepu — Shopify (mniej kosztów ukrytych). Dla dużego z dedykowanym deweloperem — PrestaShop (brak abonamentu skaluje się lepiej).",
      },
      {
        q: "Czy mogę zmigrować z Shopify na PrestaShop (lub odwrotnie)?",
        a: "Tak, choć migracje są kosztowne (8-30 tys. zł dla średniego sklepu) i wymagają dobrego planu pod SEO (przekierowania 301).",
      },
      {
        q: "Która platforma lepiej współpracuje z Allegro?",
        a: "Obie wymagają Baselinkera lub SellAsista jako pośrednika. Z poziomu BL/SA obie współpracują równie dobrze.",
      },
    ],
  },
];

export function getComparisonBySlug(slug: string): ComparisonData | undefined {
  return COMPARISONS.find((c) => c.slug === slug);
}
